module.exports = __webpack_public_path__ + "images/FUSA_icons/083-umbrella.88f0a71f3e5415a007612430648a31ec.svg";